//imports
import {
    SIM_PROVIDER_ACCOUNT_DELETE_OPEN_MODAL,
    SIM_PROVIDER_ACCOUNT_DELETE_REQUEST,
    SIM_PROVIDER_ACCOUNT_DELETE_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    result: null,
    current: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SIM_PROVIDER_ACCOUNT_DELETE_REQUEST:
            return { ...state, loading: true }

        case SIM_PROVIDER_ACCOUNT_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case SIM_PROVIDER_ACCOUNT_DELETE_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, current: action.payload.data }

        case CLEAR_REDUX:
            return ["", "SIM_PROVIDER_ACCOUNT_DELETE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};